export const CAMPAIGN_STATUS_CREATED = 'created';
export const CAMPAIGN_STATUS_PENDING = 'pending';
export const CAMPAIGN_STATUS_ACTIVE = 'active';
export const CAMPAIGN_STATUS_PAUSED = 'paused';
export const CAMPAIGN_STATUS_COMPLETED = 'completed';
